import React, { useState, useEffect, useRef } from "react";
import audiq3 from "../assets/audiadbaner.webp";
import ex90 from "../assets/ex90.webp";
// import XC90 from "../assets/XC90.webp";
import "../style/HeroCarousel.css";

const carouselData = [
  {
    image: audiq3,
    link: "https://www.audi.in/en/models/q3/q3-suv/?channelId=3309&utm_source=Auto-Car&utm_medium=Q3&utm_term=Mixed&utm_content=P2&utm_campaign=20120148_PHD_Audi_India_Q3_Launch_Performance_Campaign_Auto_Car_Q3_P2",
  },
  {
    image: ex90,
    link: "https://www.volvocars.com/us/cars/ex90-electric/",
  },
   /*
  {
    image: XC90,
    link: "https://www.volvocars.com/in/test-drive-booking/?utm_source=other&utm_medium=display&utm_content=xc90_static-image_320x100_Autocar&utm_campaign=in_xc90_consideration-action_2501_new-car_always-on_lead-generation&sourceapplicationinformation=in_x90_cat_nc",
  },
  */
];

const HeroCarousel = () => {
  const [current, setCurrent] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const length = carouselData.length;
  const timerRef = useRef(null);

  // Preload only the next image
  useEffect(() => {
    const next = (current + 1) % length;
    const img = new Image();
    img.src = carouselData[next].image;
  }, [current, length]);

  useEffect(() => {
    if (isPaused) return;

    timerRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % length);
    }, 5000);

    return () => clearInterval(timerRef.current);
  }, [isPaused, length]);

  const goToPrev = () =>
    setCurrent((prev) => (prev === 0 ? length - 1 : prev - 1));

  const goToNext = () =>
    setCurrent((prev) => (prev + 1) % length);

  return (
    <section
      className="hero-carousel"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        className="hero-slider"
        style={{
          transform: `translateX(-${current * 100}%)`,
        }}
      >
        {carouselData.map((item, index) => (
          <a
            key={index}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="hero-slide-link"
          >
            <div className="hero-slide">
              <img
                src={item.image}
                alt={`Volvo ${index + 1}`}
                className="hero-images"
                loading={index === 0 ? "eager" : "lazy"}
                fetchPriority={index === 0 ? "high" : "auto"}
                draggable="false"
              />

              <div className="hero-overlay"></div>

              <div className="hero-content">
                {/* Optional Content */}
              </div>
            </div>
          </a>
        ))}
      </div>

      <button
        className="hero-arrow left"
        onClick={goToPrev}
        aria-label="Previous"
      >
        ❮
      </button>

      <button
        className="hero-arrow right"
        onClick={goToNext}
        aria-label="Next"
      >
        ❯
      </button>

      <div className="hero-dots">
        {carouselData.map((_, i) => (
          <span
            key={i}
            className={i === current ? "dot active" : "dot"}
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroCarousel;